import { UserCompanyInfo } from "src/app/ui/models/domains/pbm/user/user-company-info";
import { CompanyParser } from "src/app/ui/repositories/parsers/pbm/company/company.parser";
import { Company } from "../companies/company";

export class UserAllowedCompaniesFactory {
  static createAllowedCompanies(payload: Array<any>): Array<Company> {
    let data: Array<Company> = new Array<Company>();
    const companyParser = new CompanyParser();
    if (Array.isArray(payload)) {
      payload.forEach((p) => {
        data.push(companyParser.parse(p));
      });
    }
    return data;
  }
}
